module.exports = __webpack_public_path__ + "img/slider_galery_23.2941cbc2.jpg";